import {Model} from "./Model";
import {IApiContestantInfo, IApiRankingEntry} from "../typings/apiResponse";
import {IContestant} from "../typings/IContestant";
import {Team} from "./Team";
import {User} from "./User";
import * as angular from "angular";

export class ContestantState {
    static NOT_SIGNED_UP: string = 'not_signed_up';
    static SIGN_UP_PENDING: string = 'sign_up_pending';
    static SIGNED_UP: string = 'signed_up';
    static CHECKED_IN: string = 'checked_in';
    static PLAYING: string = 'playing';
    static FINISHED: string = 'finished';
}

export class ContestantInfo extends Model {
    constructor(protected apiData: IApiContestantInfo) {
        super(apiData);
    }

    public getId(): string {
        return this.apiData.id;
    }

    public getState(): string {
        return this.apiData.state
    }

    public getType(): string {
        return this.apiData.type;
    }

    public hasRanking(): boolean {
        return this.apiData.state === ContestantState.FINISHED && this.apiData.rank !== null;
    }

    public getRank(): IApiRankingEntry {
        return this.apiData.rank;
    }
}